/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EGeofenceFormTabs {
  Details,
  AdvancedOptions
}
